import { Box, Typography } from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

import { bannerStyles } from "./quoteBox.style";

export const SelectedQuoteBanner = () => {
  const classes = bannerStyles();

  return (
    <Box className={`${classes.root} ${classes.selectedQuote}`}>
      <FiberManualRecordIcon color="secondary" className={classes.icon} />
      <Typography variant="subtitle2">Your Selected Quote</Typography>
    </Box>
  );
};
